<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image" (click)="BackToDohotBizoim()">
						<img src="/assets/images/header/back-arrow.svg" alt="arrow" />
					</div>
					<div class="header__title col">{{ title$ | async }}</div>
					<div class="header__burger col image">
						<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
					</div>
				</div>
			</div>
			<div class="report-table__row">
				<div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
					<!-- <button class="header__search-icon image" style="position: absolute;top: 50%;left: 5%;">
            <img src="/assets/images/header-search.svg" alt="search">
          </button> -->
					<form [formGroup]="form">
						<input class="header__search-input" type="text" placeholder="חפש" formControlName="Search" id="search-Input" style="text-align: center; direction: rtl" />
					</form>
					<button class="header__clear-icon" (click)="SearchClear()"></button>
				</div>
			</div>
		</header>

		<!--  dashboard-tables markup  -->

		<section class="dashboard-tables" *ngIf="Main === true" style="margin-top: 64px">
			<div class="content">
				<div style="display: flex; justify-content: center" *ngIf="shouldShowFilterAndTotalRow$ | async">
					<div class="fixed-header">
						<div class="report-table__button" (click)="showHideFilterPopup(true)">סינון</div>
						<ng-container *ngIf="canSeePrices">
							<div class="box">
								<div class="report-table-popup__label-title">סה"כ</div>
								<strong>{{ this.TotalArray | number : '1.0-2' : 'en-US' }}</strong>
							</div>
							<div class="box">
								<div class="report-table-popup__label-title">סה"כ סומנו</div>
								<strong>{{ this.TotalArrayChecked | number : '1.0-2' : 'en-US' }}</strong>
							</div>
						</ng-container>
					</div>
				</div>
				<!-- markup for logout popup -->

				<!-- end markup for logout popup -->

				<div class="dashboard-tables__wrapper">
					<div class="dashboard-tables__row dashboard-tables__row_scroll" style="width: 100%">
						<b>
							<table class="report-table__table" cellspacing="0" style="margin-top: 13vmax" *ngIf="isNotReclamation$ | async; else reclamationsTable">
								<thead class="report-table__table-head">
									<tr>
										<th class="report-table__table-head-name">תעודה</th>
										<th class="report-table__table-head-code" [ngStyle]="{ minWidth: (isNotTeudotForConfirm$ | async) ? null : '120px' }">שם לקוח</th>

										<ng-container *ngIf="canSeePrices">
											<th class="report-table__table-head-quantity">סכום</th>
										</ng-container>

										<th class="report-table__table-head-quantity" [ngStyle]="{ minWidth: (isNotTeudotForConfirm$ | async) ? '100px' : null }">תאריך</th>
										<ng-container *ngIf="isNotTeudotForConfirm$ | async">
											<th class="report-table__table-head-quantity">שעה</th>
											<th class="report-table__table-head-quantity">שורות</th>
											<th class="report-table__table-head-quantity">סטטוס</th>
											<th class="report-table__table-head-quantity">חברה</th>
											<th class="report-table__table-head-quantity">סוג תעודה</th>
											<th class="report-table__table-head-quantity">ERP סטטוס</th>
										</ng-container>
										<th class="report-table__table-head-quantity">{{ lastColumnTitle$ | async }}</th>
									</tr>
								</thead>
								<tbody class="report-table__table-body">
									<tr *ngFor="let t of AllOrdersBitzoimPerAgent; let i = index">
										<ng-template #teudaNumSlicedBlock>
											<td class="report-table__table-body-name clickable" style="color: red" (click)="seeTeuda(t.TeudaNum, i, t.TeudaNum.toString().slice(7, 13))">
												{{ t.TeudaNum.toString().slice(7, 13) }}
											</td>
										</ng-template>
										<ng-container *ngIf="t.TeudaNewNum.length > 1; else teudaNumSlicedBlock">
											<td
												class="report-table__table-body-name clickable"
												*ngIf="isNotTeudotForConfirm$ | async; else teudaForConfirmTeudaNum"
												style="color: #38d88b"
												(click)="seeTeuda(t.TeudaNum, i, t.TeudaNewNum)"
											>
												{{ t.TeudaNewNum }}
											</td>
											<ng-template #teudaForConfirmTeudaNum>
												<td class="report-table__table-body-name clickable" style="color: #38d88b" (click)="seeTeudaAgentForConfirm(t)">
													{{ t.TeudaNewNum }}
												</td>
											</ng-template>
										</ng-container>
										<td class="report-table__table-body-name">{{ t.Client_Name }}</td>

										<td class="report-table__table-body-quantity" dir="ltr" *ngIf="canSeePrices">{{ t.TeudaTotalSum | number : '1.0-2' : 'en-US' }}</td>
										<td class="report-table__table-body-quantity">
											<ng-container *ngIf="isNotTeudotForConfirm$ | async; else cutDateBlock">
												{{ t.TeudaShowDate }}
											</ng-container>
											<ng-template #cutDateBlock>
												{{ t.TeudaShowDate.slice(0, 5) }}
											</ng-template>
										</td>
										<ng-container *ngIf="isNotTeudotForConfirm$ | async">
											<td class="report-table__table-body-quantity">{{ t.TeudaShowTime }}</td>
											<td class="report-table__table-body-quantity">{{ t.TotalLines }}</td>
											<td class="report-table__table-body-quantity">{{ t.Status }}</td>
											<td class="report-table__table-body-quantity">{{ companyDictionary[t.Company] || t.Company }}</td>
											<td class="report-table__table-body-quantity">{{ docTypeHash[t.TeudaType] || 'אין נתון' }}</td>
											<td class="report-table__table-body-quantity">{{ t.TuedaErpDocNum }}</td>
										</ng-container>
										<td class="report-table__table-body-quantity" *ngIf="isNotTeudotForConfirm$ | async; else teudotForConfirmBlock">
											<mat-checkbox color="primary" [checked]="checkedObject[t.TeudaNum]" (change)="OrderChecked(t.TeudaNum, t.TeudaTotalSum)"></mat-checkbox>
										</td>
										<ng-template #teudotForConfirmBlock>
											<td class="report-table__table-body-quantity">
												<!-- <button mat-raised-button color="primary">אשר</button> -->
												<button mat-raised-button (click)="seeTeudaAgentForConfirm(t)" color="primary">פתח</button>
											</td>
											<!-- <td class="report-table__table-body-quantity"> -->
											<!-- <button mat-raised-button color="primary">אשר</button> -->
											<!-- <button mat-raised-button (click)="selectedTeudaNumForConfirm$.next({ TeudaNum: t.TeudaNum, TeudaNewNum: t.TeudaNewNum, action: 'delete' })">בטל</button> -->
											<!-- </td> -->
										</ng-template>
									</tr>
								</tbody>
							</table>

							<ng-template #reclamationsTable>
								<table class="report-table__table" cellspacing="0" style="margin-top: 13vmax">
									<thead class="report-table__table-head">
										<tr>
											<th class="report-table__table-head-name">תעודה</th>
											<th class="report-table__table-head-code">שם לקוח</th>
											<th class="report-table__table-head-quantity">תאריך</th>
											<th class="report-table__table-head-quantity">שעה</th>
											<th class="report-table__table-head-quantity">סטטוס</th>
										</tr>
									</thead>
									<tbody class="report-table__table-body">
										<tr *ngFor="let t of AllOrdersBitzoimPerAgent">
											<td class="report-table__table-body-name" style="color: #38d88b">{{ t.RekID }}</td>
											<td class="report-table__table-body-name">{{ t.Client_Name || 'אין נתון' }}</td>
											<td class="report-table__table-body-quantity">{{ t.CreateDate | date : 'dd.MM.yyyy' }}</td>
											<td class="report-table__table-body-quantity">{{ t.CreateDate | returnTimeFormatted : true }}</td>
											<td class="report-table__table-body-quantity">{{ t.Status }}</td>
										</tr>
									</tbody>
								</table>
							</ng-template>
						</b>
					</div>
				</div>
			</div>
		</section>
		<!--  end dashboard-tables markup  -->
	</div>

	<div class="popup" *ngIf="showFilterPopup">
		<div class="overlay"></div>
		<div class="report-table-popup report-table-popup_sort popup__content">
			<div class="popup__close" (click)="showHideFilterPopup(false)"></div>
			<div class="report-table-popup__header">
				<div class="report-table-popup__header-search"></div>
			</div>
			<div class="report-table-popup__wrapper">
				<div class="report-table-popup__content">
					<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border report-table-popup__row_padding"></div>
					<div class="report-table-popup__row report-table-popup__row_no-border report-table-popup__row_double">
						<div class="report-table-popup__box" style="width: 100%">
							<form [formGroup]="form" dir="rtl">
								<div class="report-table-popup__box with-border-bottom">
									<div class="popup-select-title">לפי תקופה</div>
									<mat-form-field color="primary" appearance="fill" style="scale: 0.8; max-width: 75%">
										<mat-date-range-input [rangePicker]="picker" [dateFilter]="dateFilterFunction" (click)="picker.open()">
											<input matStartDate readonly="true" formControlName="from" />
											<input matEndDate readonly="true" formControlName="to" (dateChange)="ChooseDate()" />
										</mat-date-range-input>
										<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
										<mat-date-range-picker #picker></mat-date-range-picker>
									</mat-form-field>
								</div>
							</form>
							<div class="report-table-popup__box with-border-bottom">
								<div class="popup-select-title">סוג תעודה</div>
								<mat-form-field color="primary" appearance="fill" dir="rtl" style="transform: scale(0.8) translateY(10px)">
									<mat-select [formControl]="docTypesControl" multiple (valueChange)="handleChangeDoctype($event)">
										<mat-option *ngFor="let d of docTypes; let i = index" [value]="d">{{ d.DocName }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="report-table-popup__box button-row">
								<button mat-raised-button color="primary" (click)="resetSort()">אפס</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="popup" *ngIf="LoadingSeeTeuda || SeeTeudaLoaded" style="z-index: 555">
		<div class="overlay" (click)="handleClosePopup()"></div>
		<div class="product-detail__title">
			<span *ngIf="selectedTeudaToOpenPopup?.Client_Name">
				{{ selectedTeudaToOpenPopup.Client_Name }}
			</span>
			<span *ngIf="selectedTeudaNum">
				{{ selectedTeudaNum }}
			</span>
			<div class="remarks" *ngIf="(remarks.length || selectedTeudaToOpenPopup.remark) && !isRemarkPopupOpen">
				<span *ngIf="selectedTeudaToOpenPopup.remark" style="font-weight: 700">הערת תעודה ראשית: {{ selectedTeudaToOpenPopup.remark }}</span
				><button *ngIf="remarks.length" mat-raised-button color="primary" (click)="isRemarkPopupOpen = true">הצג הערות</button>
			</div>
		</div>
		<div class="product-detail__title bottom" dir="rtl" *ngIf="isTeudotForConfirm$ | async">
			<button
				mat-raised-button
				[disabled]="(canSubmitTeudaConfirm$ | async) === false"
				color="primary"
				style="background: var(--valid-color) !important"
				(click)="selectedTeudaNumForConfirm$.next({ TeudaNum: selectedTeudaToOpenPopup.TeudaNum, TeudaNewNum: selectedTeudaToOpenPopup.TeudaNewNum, action: 'confirm' })"
			>
				שלח
			</button>
			<button
				mat-raised-button
				[disabled]="(canSubmitTeudaConfirm$ | async) === false"
				color="primary"
				(click)="selectedTeudaNumForConfirm$.next({ TeudaNum: selectedTeudaToOpenPopup.TeudaNum, TeudaNewNum: selectedTeudaToOpenPopup.TeudaNewNum, action: 'delete' })"
			>
				בטל
			</button>
		</div>
		<div
			class="product-detail-popup popup__content"
			[ngClass]="{ 'with-remark': (remarks.length || selectedTeudaToOpenPopup.remark) && !isRemarkPopupOpen }"
			*ngIf="!isRemarkPopupOpen; else elseBlock"
		>
			<div class="popup__close" (click)="handleClosePopup()" style="width: 30px; height: 30px; background-color: black" *ngIf="!LoadingSeeTeuda"></div>
			<div class="product-detail__wrapper">
				<ng-container *ngIf="SeeTeudaLoaded; else loadingSeeTeudaBlock">
					<table>
						<tr class="fixed-table-headers">
							<ng-container *ngIf="isTeudotForConfirm$ | async">
								<th style="position: sticky; right: 0; z-index: 1; background: white">אשר</th>
							</ng-container>
							<th style="min-width: 140px">שם פריט</th>
							<th>קוד פריט</th>
							<th>יחידות</th>
							<th>{{ _text.packQuantityText }}</th>
							<th>בונוס</th>
							<ng-container *ngIf="canSeePrices">
								<th>מחיר</th>
								<th>הנחה</th>
								<th>מחיר נטו</th>
								<th>מחיר סופי</th>
							</ng-container>
							<th>הערה</th>
						</tr>
						<ng-container *ngIf="isNotTeudotForConfirm$ | async; else teudotForConfirmBlock">
							<tr *ngFor="let pte of TeudotTableEach.length ? TeudotTableEach : TeudotEach">
								<td>{{ pte.ProductName }}</td>
								<td>{{ pte.ProductId }}</td>
								<td>{{ pte.TeudaQuantity | number : '1.0-3' }}</td>
								<td>{{ pte.TeudaPackQuantity | number : '1.0-3' }}</td>
								<td>{{ pte.TeudaBonusQuantity | number : '1.0-3' }}</td>
								<ng-container *ngIf="canSeePrices">
									<td>{{ pte.TeudaPrice | number : '1.0-3' }}</td>
									<td>{{ pte.TeudaItemDiscount | number : '1.0-2' }}</td>
									<td>{{ pte.TeudaItemNetPrice | number : '1.0-3' }}</td>
									<td>{{ pte.TeudaTotalRow | number : '1.0-3' }}</td>
								</ng-container>
								<td>{{ pte.TeudaItemRemark }}</td>
							</tr>
						</ng-container>
						<ng-template #teudotForConfirmBlock>
							<tr *ngFor="let pte of TeudotTableEach.length ? TeudotTableEach : TeudotEach; index as i">
								<td style="position: sticky; right: 0; z-index: 1; background: white">
									<mat-checkbox [formControl]="teudaConfirmCheckboxesFormArray.at(i)" color="primary"></mat-checkbox>
								</td>
								<td>{{ pte.ProductName }}</td>
								<td>{{ pte.ProductId }}</td>
								<td>
									<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaQuantity" [previousData]="pte.previousTeudaQuantity"></app-dohot-bizoim-azmanot-table-data>
								</td>
								<td>
									<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaPackQuantity" [previousData]="pte.previousTeudaPackQuantity"></app-dohot-bizoim-azmanot-table-data>
								</td>
								<td>
									<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaBonusQuantity" [previousData]="pte.previousTeudaBonusQuantity"></app-dohot-bizoim-azmanot-table-data>
								</td>
								<ng-container *ngIf="canSeePrices">
									<td>
										<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaPrice" [previousData]="pte.previousTeudaPrice"></app-dohot-bizoim-azmanot-table-data>
									</td>
									<td>
										<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaItemDiscount" [previousData]="pte.previousTeudaItemDiscount"></app-dohot-bizoim-azmanot-table-data>
									</td>
									<td>
										<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaItemNetPrice" [previousData]="pte.previousTeudaItemNetPrice"></app-dohot-bizoim-azmanot-table-data>
									</td>
									<td>
										<app-dohot-bizoim-azmanot-table-data [currentData]="pte.TeudaTotalRow" [previousData]="pte.previousTeudaTotalRow"></app-dohot-bizoim-azmanot-table-data>
									</td>
								</ng-container>
								<td>{{ pte.TeudaItemRemark }}</td>
							</tr>
						</ng-template>
						<tr class="fixed-table-footers">
							<th *ngFor="let row of selectedTeudaTotalsArray">
								<span class="footer-separator"></span>
								{{ selectedTeudaTotals[row] !== undefined ? (selectedTeudaTotals[row] | number : '1.0-2') : row }}
							</th>
						</tr>
					</table>
				</ng-container>
				<ng-template #loadingSeeTeudaBlock>
					<div class="product-detail__wrapper__already-sent">
						טוען תעודה, אנא המתינו...
						<mat-spinner diameter="50" color="primary"></mat-spinner>
					</div>
				</ng-template>
			</div>
		</div>
		<ng-template #elseBlock>
			<div class="order-cart__popup popup__content">
				<div class="popup__close" (click)="isRemarkPopupOpen = false"></div>
				<div class="order-cart__popup-image image">
					<img src="/assets/images/basket/cancel-icon.gif" alt="photo" />
				</div>
				<h2 class="order-cart__popup-title">הערות</h2>
				<div class="order-cart__popup-block-wrapper">
					<div class="order-cart__popup-block column" *ngFor="let remark of remarks; let i = index">
						<h3 class="remark_title" *ngIf="remark">
							{{ i | getRemarkHeader }}
						</h3>
						<div class="client-details__item-name margin-bottom" *ngIf="remark">
							{{ remark }}
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
	<ng-container *ngIf="selectedTeudaNumForConfirm$ | async as teudaState">
		<div class="popup" *ngIf="teudaState.TeudaNum" style="z-index: 655">
			<div class="overlay" (click)="closeTeudaNumForConfirm()"></div>
			<div class="product-detail-popup popup__content">
				<div class="popup__close" (click)="closeTeudaNumForConfirm()" style="width: 30px; height: 30px; background-color: black"></div>
				<div class="product-detail__wrapper">
					<ng-container [ngSwitch]="teudaForConfirmLoadingState$ | async">
						<div class="grid" *ngSwitchCase="'idle'" style="grid-template-columns: repeat(1, 1fr); grid-template-rows: 1fr 2fr">
							<h2 class="text-align-center rtl">האם הנך בטוח שתרצה {{ teudaState.action === 'delete' ? 'לבטל' : 'לאשר' }} את תעודה מספר {{ teudaState.TeudaNewNum }} ?</h2>
							<div class="product-detail__wrapper__already-sent" style="height: initial; flex-direction: row">
								<button mat-raised-button *ngIf="teudaState.action === 'confirm'" (click)="sendToConfirm(teudaState.TeudaNum, teudaState.TeudaNewNum)" color="primary">שלח</button>
								<button mat-raised-button *ngIf="teudaState.action === 'delete'" (click)="changeTeudaStatusToSix()" color="primary">מחק</button>
								<button mat-raised-button (click)="closeTeudaNumForConfirm()">בטל</button>
							</div>
						</div>
						<div class="product-detail__wrapper__already-sent" *ngSwitchCase="'loading'">
							טוען , אנא המתינו...
							<mat-spinner diameter="50" color="primary"></mat-spinner>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<div class="popup" *ngIf="isRemarkPopupOpen">
	<div class="overlay"></div>
</div>
